<template>
  <div>
    <loading :loading="isLoading" msg="Carregando oferta" />
    <div class="row" v-if="offer">
      <div class="col-md-5 col-sm-5">
        <b-carousel
          id="carousel-fade"
          style="text-shadow: 0px 0px 2px #000"
          fade
          indicators
          img-width="1024"
          img-height="480"
          v-model="slide"
        >
          <b-carousel-slide
            v-for="(image, index) in offer.product_variation.images"
            :img-src="baseUrl + image.url" :key="index"
          ></b-carousel-slide>
        </b-carousel>
        <div class="offer_thumbs row">
          <div
            class="col-sm-3"
            v-for="(image, index) in offer.product_variation.images"
            :key="index"
          >
            <a @click="setSlide(index)"
              ><img
                class="thumbnail"
                :src="baseUrl + image.url"
                :class="{ active: slide == index }"
            /></a>
          </div>
        </div>
      </div>
      <div class="col-md-7 col-sm-7">
        <h2 class="title">{{ offer.product_variation.name }}</h2>
        <tags :tags="offer.product_variation.tags" />
        <div class="row">
          <div class="col">
            <h3 class="main-price">{{ offer.final_price | moeda }}</h3>
            <p
              v-if="
                offer.product_variation.box_qtd &&
                  offer.product_variation.box_qtd.value
              "
            >
              {{ offer.product_variation.box_qtd.value }}
              {{ offer.product_variation.box_qtd.unit }} por caixa/embalagem
            </p>
          </div>
          <div class="col">
            <div class="add_to_cart text-right">
              <input
                type="number"
                class="form-control"
                v-model="qtd"
                :min="offer.minimum_order"
                :max="offer.qtd - offer.qtd_ordered"
              />
              <button class="btn btn-primary" @click="buy">
                {{ totalPrice ? 'alterar quantidade' : 'pagar' }} &#xA0;<i class="fa fa-shopping-cart"></i>
              </button>
              <small
                ><br />{{ offer.qtd - offer.qtd_ordered }} disponíveis</small
              >
            </div>
          </div>
        </div>
        <div>
          <div class="card card-collapse">
            <div class="card-header">
              <h5 class="mb-0">
                Condições de compra
              </h5>
            </div>
            <div class="card-body">
             <div v-html="offer.order_conditions"></div>
              <table class="product-info">
                <tbody>
                  <tr v-if="offer.invoice_issuer">
                    <td>Quantidade minima:</td>
                    <th class="text-right">{{ offer.minimum_order }}</th>
                  </tr>


                </tbody>
              </table>
            </div>
          </div>
          <div class="card card-collapse">
            <div class="card-header">
              <h5 class="mb-0">
                Envio
              </h5>
            </div>
            <div class="card-body">
              <table class="product-info">
                <tbody>
                  <tr v-if="offer.invoice_issuer">
                    <td>Condições de entrega:</td>
                    <th class="text-right">{{ offer.delivery_conditions }}</th>
                  </tr>
                  <tr v-if="offer.address && offer.address.description">
                    <td>Origem do envio:</td>
                    <th class="text-right">
                      <small>{{offer.address.description}}</small>
                    </th>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div v-if="totalPrice">
            <iframe
              width="100%"
              priority="high"
              height="1300px"
              scrollable="false"
              :src="gatewayUrl"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Loading from "@/components/Loading";
import Tags from "@/components/Tags";

export default {
  name: "Offer",

  data() {
    return {
      offer: null,
      slide: 0,
      qtd: 0,
      totalPrice: null,
      gatewayUrl: "",
      relatedOffers: [],
    };
  },

  async created() {
    this.fetchOffer();
  },

  methods: {
    fetchOffer() {
      this.isLoading = true;

      axios
        .get("collective_offers/" + this.$route.params.id)
        .then(({ data }) => {
          const { offer, ...collectiveOffer } = data;
          this.offer = { ...offer, ...collectiveOffer };
          this.qtd = collectiveOffer.minimum_order;
          this.isLoading = false;
        })
        .catch(this.showError);
    },
    setSlide(slide) {
      this.slide = slide;
    },
    buy() {
      this.totalPrice = this.qtd * this.offer.final_price;
      this.gatewayUrl = `https://welight.live/pagamento-bioba/?pagetype=gateway&amount=${
        this.totalPrice
      }`;
    },
  },
  watch: {
    $route(to, from) {
      if (to.path !== from.path) {
        this.fetchOffer();
      }
    },
  },
  components: {
    Loading,
    Tags,
  },
};
</script>
<style lang="sass">
iframe
  border: none
</style>
